import { Controller } from "@hotwired/stimulus"
import axios from "axios"

// Personalizacja lewego sidebara "Podręczne" (per konto, widok /account/settings, admin).
// Łączy drag&drop kolejności z checkboxami widoczności. Po każdej zmianie (upuszczenie
// lub przełączenie checkboxa) zapisuje pełną listę [{ key, on }] w kolejności DOM-u do
// account.fields.account.sidebar.items przez /account/set_field (target=account).
// Rejestrowany w controllers/index_account.js (ładowany w widokach /account), nie w globalnym manifeście.
//
// Wymagane data-attributes na kontenerze:
//   data-controller="sidebar-menu"
//   data-sidebar-menu-save-url-value="<%= account_set_field_path %>"
//   data-sidebar-menu-key-value="account.sidebar.items"
//   data-action="dragstart->... dragover->... drop->... dragend->..."
// Każdy wiersz: draggable="true", data-sidebar-menu-target="item", data-key="modul:code",
// z checkboxem data-action="change->sidebar-menu#toggle".
export default class extends Controller {
  static targets = ["item"]
  static values = { saveUrl: String, key: String }

  dragstart(event) {
    const item = event.target.closest("[data-sidebar-menu-target='item']")
    if (!item) {
      event.preventDefault()
      return
    }
    this.draggedItem = item
    event.dataTransfer.effectAllowed = "move"
    item.classList.add("opacity-40")
  }

  dragover(event) {
    if (!this.draggedItem) return
    event.preventDefault()

    const target = event.target.closest("[data-sidebar-menu-target='item']")
    if (!target || target === this.draggedItem) return

    const rect = target.getBoundingClientRect()
    const insertBefore = event.clientY < rect.top + rect.height / 2
    if (insertBefore) {
      target.parentNode.insertBefore(this.draggedItem, target)
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
    }
  }

  drop(event) {
    event.preventDefault()
  }

  dragend() {
    if (!this.draggedItem) return
    this.draggedItem.classList.remove("opacity-40")
    this.draggedItem = null
    this.save()
  }

  toggle() {
    this.save()
  }

  // zbiera aktualną kolejność i stan checkboxów, zapisuje całą listę [{ key, on }]
  save() {
    const items = this.itemTargets.map((el) => ({
      key: el.dataset.key,
      // brak checkboxa (nietypowy wiersz) traktujemy jako widoczny, zamiast wywalać cały zapis
      on: el.querySelector("input[type=checkbox]")?.checked ?? true,
    }))

    axios.post(this.saveUrlValue, null, {
      params: {
        target: "account",
        key: this.keyValue,
        value: JSON.stringify(items),
      },
      headers: { Accept: "application/json" }
    }).catch((error) => {
      console.error("sidebar menu save failed", error)
    })
  }
}
